import(/* webpackMode: "eager", webpackExports: ["ReadingProgress"] */ "/tmp/8dedc5c185aba8d/components/blog/ReadingProgress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareButtons"] */ "/tmp/8dedc5c185aba8d/components/blog/ShareButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TableOfContents"] */ "/tmp/8dedc5c185aba8d/components/blog/TableOfContents.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/blog/BlogCard.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/blog/RelatedPosts.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/blog/PrevNextNav.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/app/[locale]/blog/[slug]/page.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/node_modules/next/dist/client/link.js");
